<template>
  <div class="content-event-and-training">
    <div>
      <b-card>
        <h6 class="mb-4 font-weight-bold">Filter</h6>
          <b-row align-v="center">
            <b-col>
              <b-form-group
                label="Status"
              >
                <custom-select
                  v-model="filterEventTraining"
                  :options="eventTrainingFilter.filters"
                  multiple
                  @change="$refs.table.refresh()"
                  placeholder="Select status"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <div class="button-project mt-2 d-flex justify-content-end">
                <b-button
                  class="reset mr-3"
                  variant="outline-warning"
                  @click="resetFilter"
                >
                  Reset Filter
                </b-button>
                <b-button
                  class="next"
                  variant="warning"
                  @click="applyFilter"
                >
                Apply Filter
              </b-button>
              </div>
            </b-col>
          </b-row>
      </b-card>
    </div>
    <div class="table-list my-4">
      <div class="text-white py-3">
        <b-button variant="warning" @click="openModalForm">Create Event/Training</b-button>
        <div>
          <modal-form-event-training
            :text="text"
            :modeUpdate="modeUpdate"
            :dataUpdate="singlePickEvent"
            :employee="employees"
            @result-request="recieveDataFromModal"
          />
        </div>
      </div>
      <div>
        <b-row v-show="!events.length">
          <b-col>
            <div align="center">
            <img src="@/assets/icon-no-invoice.png"/>
          </div>
          </b-col>
        </b-row>
        <b-table
          v-show="events.length"
          ref="table"
          striped
          :items="fetchListEventTraining"
          :fields="fields"
          responsive
          @refresh-table="refreshTable"
        >
        <template #cell(no)="{ index }">
          {{ index + 1 }}
          </template>
          <template #cell(startDate)="data">
            <div>
              {{ formatFullDate(data.value) }}
            </div>
          </template>
          <template #cell(endDate)="data">
            <div>
              {{ formatFullDate(data.value) }}
            </div>
          </template>
          <template #cell(participant)="data">
            <div>
              <b-link @click="openModalAdd(data.item)" class="text-secondary mx-2">
                <fa-icon icon="user-friends"/>
              </b-link>
              <b-link @click="openModalParticipants(data.item)" class="text-secondary mx-2">
                <fa-icon icon="bars">
                  {{ data.item.participants }}
                </fa-icon>
              </b-link>
            </div>
          </template>
          <template #cell(action)="{ item }">
            <div class="data" >
              <b-link
                class="text-secondary mx-2"
              >
              <fa-icon icon="edit" @click="openModalFormUpdate(item)"/>
            </b-link>
            <b-link
            class="text-secondary mx-2"
            >
            <fa-icon icon="eye" @click="openModalView(item)"/>
          </b-link>
          <b-link
          class="text-secondary mx-2"
          >
          <fa-icon v-b-modal.modal-center icon="trash" @click="openModalConfirmDelete(item)"/>
        </b-link>
      </div>
    </template>
  </b-table>
  <modal-add-participants
    :text="text"
    :dataUpdate="singlePickEvent"
    :employee="employees"
    :listParticipant="listParticipants"
    @result-request="recieveDataFromModal"
  />
  <modal-participants
    :employee="employees"
    :text="text"
    :listParticipant="listParticipants"
    :eventTraining="singlePickEvent"
  />
  <modal-delete-event-training
    :eventTrainingName="formDelete.title"
    @remove="deleteEventTraining"
  />
  <modal-view-event-training
    :text="text"
    :eventTraining="singlePickEvent"
  />
  <div class="d-flex justify-content-between mt-4">
    <div>
      <span>Show</span>
      <b-form-select
      v-model="perPage"
      :options="pageOptions"
              @change="$refs.table.refresh()"
              class="page-option ml-2 mr-2 w-auto"
              size="sm"
            />
            <span>Entries</span>
          </div>
          <div>
            <b-pagination
              class="mb-0"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              pills
              hide-goto-end-buttons
              @input="$refs.table.refresh()"
            />
            <span class="show-entries mr-auto">
              {{
              `Show ${
                totalRows === 0 ? 0 : (currentPage - 1) * perPage + 1
              } to ${
                totalRows > currentPage * perPage
                  ? currentPage * perPage
                  : totalRows
              } of ${totalRows} entries`
            }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import ModalFormEventTraining from './ModalFormEventTraining'
import ModalDeleteEventTraining from './ModalDeleteEventTraining'
import ModalViewEventTraining from './ModalViewEventTraining'
import ModalParticipants from './ModalParticipants'
import ModalAddParticipants from './ModalAddParticipants'
export default {
  components: {
    ModalFormEventTraining,
    ModalParticipants,
    ModalAddParticipants,
    ModalDeleteEventTraining,
    ModalViewEventTraining
  },
  data() {
    return {
      events: [
        {
          budget: '',
          dayLength: '',
          description: '',
          endDate: '',
          id: '',
          method: '',
          participants: 0,
          report: '',
          startDate: '',
          statusBudget: '',
          title: ''
        }
      ],
      fields: [
        { key: 'no', label: 'No' },
        { key: 'title', label: 'Name Event' },
        { key: 'startDate', label: 'Start Date', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'endDate', label: 'End Date', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'participant', label: 'Partisipant', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'action', label: 'Action', thClass: 'text-center', tdClass: 'text-center' }
      ],
      employees: [],
      filterEventTraining: ['Paid'],
      eventTrainingFilter: {
        show: true,
        filters: ['Paid', 'Pending', 'None']
      },
      singlePickEvent: {
        budget: '',
        dayLength: '',
        description: '',
        endDate: '',
        id: '',
        method: '',
        participants: 0,
        report: '',
        startDate: '',
        statusBudget: '',
        title: ''
      },
      listParticipants: [],
      formDelete: {},
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      totalPage: 0,
      pageOptions: [10, 20, 50, 100],
      text: '',
      modeUpdate: false
    }
  },
  computed: {
    formattedStartDate() {
      return this.formatFullDate(this.events.startDate)
    },
    formattedEndDate() {
      return this.formatFullDate(this.events.endDate)
    }
  },
  methods: {
    async fetchListEventTraining() {
      let paramStatus = ''
      paramStatus = this.filterEventTraining
      try {
        const { data } = await api.eventTraining.getList({
          page: this.currentPage,
          pageSize: this.perPage,
          sorts: this.sortBy
        })
        this.events = data.data.length !== 0 ? data.data : []
        this.totalRows = data.length !== 0 ? data.totalData : 0
        this.totalPage = data.totalPage
        this.events = this.events.filter((event) => {
          if (paramStatus.includes('Paid') && event.statusBudget === 0) {
            return true
          }
          if (paramStatus.includes('Pending') && event.statusBudget === 1) {
            return true
          }
          if (paramStatus.includes('None') && event.statusBudget === 2) {
            return true
          }
          return false
        })
        this.events.map((v, i) => {
          if (i % 2 === 0) {
            v._rowVariant = 'warning'
          }
        })
        this.fetchEmployees()
        this.fetchListParticipants()
      } catch (error) {
        console.log(error)
      }
      // this.events = this.events.filter((v) => v.statusBudget === paramStatus)
      return this.events
    },
    async fetchListParticipants() {
      try {
        const { data } = await api.eventTraining.getListParticipants({
          page: this.currentPage,
          pageSize: this.perPage,
          Filters: `eventId==${this.singlePickEvent.id}`,
          sorts: this.sortBy
        })
        this.listParticipants = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async fetchEmployees() {
      try {
        const { data } = await api.employee.list({
          page: 1,
          pageSize: 100,
          Filters: 'Status==True',
          sorts: 'fullName'
        })
        this.employees = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async deleteEventTraining() {
      try {
        await api.eventTraining.deleteEvent(this.formDelete.id)
        this.$bvToast.toast('Delete Event/Training Success', {
          headerClass: 'd-none',
          solid: true,
          variant: 'success'
        })
        this.$refs.table.refresh()
      } catch (error) {
        console.log(error)
      }
      this.deleteEventDetail()
    },
    async deleteEventDetail() {
      const listDeleteEventDetail = this.listParticipants
        .filter(item => item.eventId === this.singlePickEvent.id)
        .map(item => item.id)
      try {
        await Promise.all(listDeleteEventDetail.map(async item => {
          await api.eventTraining.deleteEventDetail(item)
        }))
        this.listParticipants = []
      } catch (error) {
        console.error('Error deleting event details:', error)
      }
    },
    openModalConfirmDelete(item) {
      this.$bvModal.show('modal-delete-event-training')
      this.formDelete = { ...item }
    },
    openModalForm() {
      this.text = 'Create Event/Training'
      this.modeUpdate = false
      this.singlePickEvent = {
        budget: '',
        dayLength: '',
        description: '',
        endDate: '',
        method: '',
        participants: 0,
        report: '',
        startDate: '',
        statusBudget: '',
        title: ''
      }
      this.$bvModal.show('modal-form-event-training')
    },
    openModalAdd(item) {
      this.text = 'Add Participants'
      this.modeUpdate = true
      this.singlePickEvent = item
      this.$bvModal.show('modal-add-participants')
    },
    openModalParticipants(item) {
      this.text = 'Participants Detail'
      this.singlePickEvent = item
      this.$bvModal.show('modal-participants')
    },
    openModalView(item) {
      this.text = 'View Event/Training'
      this.singlePickEvent = item
      this.$bvModal.show('modal-view-event-training')
    },
    openModalFormUpdate(item) {
      this.text = 'Update Event/Training'
      this.modeUpdate = true
      this.singlePickEvent = item
      this.$bvModal.show('modal-form-event-training')
    },
    recieveDataFromModal(data) {
      this.$nextTick(() => {
        this.$bvToast.toast(data.text, {
          headerClass: 'd-none',
          solid: true,
          variant: data.variantAlert
        })
        this.$refs.table.refresh()
      })
    },
    resetFilter() {
      this.filterEventTraining = this.$options.data().filterEventTraining
      this.$refs.table.refresh()
    },
    refreshTable() {
      this.$refs.table.refresh()
    },
    applyFilter() {
      this.$refs.table.refresh()
    },
    getDayName(dayIndex) {
      const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
      return days[dayIndex]
    },
    getMonthName(monthIndex) {
      const months = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
      ]
      return months[monthIndex]
    },
    formatFullDate(dateTimeString) {
      if (dateTimeString) {
        const dateObj = new Date(dateTimeString)
        const day = this.getDayName(dateObj.getDay())
        const date = dateObj.getDate()
        const month = this.getMonthName(dateObj.getMonth())
        const year = dateObj.getFullYear()
        const formattedTime = dateObj.toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit'
        })

        return `${day}, ${date} ${month} ${year} ${formattedTime}`
      } else {
        return 'Invalid Date'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-list{
  background-color: white;
  border-radius: 6px;
  padding: 15px;
  border: 1px solid #e6e6e6;
}
</style>
